module.exports = __webpack_public_path__ + "static/media/ogl2.png.74f53137.jpg";